import { Checkbox, Col, Form, FormProps, Input, Modal, ModalProps, Row, Select, useSelect, Button } from '@pankod/refine-antd'
import React, { useState } from 'react'
import type { RangePickerProps } from 'antd/es/date-picker'
import dayjs from 'dayjs'
import { DatePicker } from 'antd'

interface TaskCreateProps {
  modalProps: ModalProps
  formProps: FormProps
  users: any
  close: () => void
  managerId: string
  permission: any
  onChangePermission: any
}

const SupportTaskCreate: React.FC<TaskCreateProps> = ({ modalProps, formProps, users, close, managerId, onChangePermission, permission }) => {
  // const [modulePermissions, SetModulePermissions] = useState<any>(null)
  console.log('modal_props', modalProps)
  const { selectProps: moduleProps } = useSelect({
    resource: 'modules',
    optionLabel: 'label',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'label'],
    },
    onSearch: value => [
      {
        field: 'label',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
    queryOptions: {
      enabled: modalProps?.visible === true,
    },
  })
  // eslint-disable-next-line arrow-body-style
  const disabledDate: RangePickerProps['disabledDate'] = current => {
    // Can not select days before today and today
    return current && current < dayjs().add(-1, 'day')
  }
  const onCancel = async () => {
    close()
    formProps?.form?.resetFields()
  }
  const onCheckRead = (event: any, idx: number) => {
    // formProps?.form?.setFieldsValue({
    //                     can_read: e?.target?.checked,
    //                   })
    //                 }
    const arr = [...permission]
    const index = arr.findIndex((mod: any, index: number) => index === idx)
    const copyOfIndexObject = { ...arr[index] }
    copyOfIndexObject.can_read = event?.target?.checked
    arr[index] = copyOfIndexObject
    onChangePermission(arr)
  }
  const onCheckCreate = (event: any, idx: number) => {
    // formProps?.form?.setFieldsValue({
    //                     can_read: e?.target?.checked,
    //                   })
    //                 }
    const arr = [...permission]
    const index = arr.findIndex((mod: any, index: number) => index === idx)
    const copyOfIndexObject = { ...arr[index] }
    copyOfIndexObject.can_create = event?.target?.checked
    arr[index] = copyOfIndexObject
    onChangePermission(arr)
  }
  const onCheckUpd = (event: any, idx: number) => {
    // formProps?.form?.setFieldsValue({
    //                     can_read: e?.target?.checked,
    //                   })
    //                 }
    const arr = [...permission]
    const index = arr.findIndex((mod: any, index: number) => index === idx)
    const copyOfIndexObject = { ...arr[index] }
    copyOfIndexObject.can_update = event?.target?.checked
    arr[index] = copyOfIndexObject
    onChangePermission(arr)
  }
  const onCheckDel = (event: any, idx: number) => {
    // formProps?.form?.setFieldsValue({
    //                     can_read: e?.target?.checked,
    //                   })
    //                 }
    const arr = [...permission]
    const index = arr.findIndex((mod: any, index: number) => index === idx)
    const copyOfIndexObject = { ...arr[index] }
    copyOfIndexObject.can_delete = event?.target?.checked
    arr[index] = copyOfIndexObject
    onChangePermission(arr)
  }
  const onFinish = async (data: any) => {
    const { assignee_id, module_id, start_date, end_date, name, description, ...rest } = data
    const task_object = {
      name,
      assignee_id,
      // module_id,
      description,
      start_date: dayjs(start_date).format('YYYY-MM-DD'),
      end_date: dayjs(end_date).format('YYYY-MM-DD'),
      created_by: managerId,
      status: 'Assigned',
    }
    if (formProps?.onFinish) {
      formProps?.onFinish({
        ...task_object,
        // permissions: {
        //   data: [
        //     {
        //       support_id: assignee_id,
        //       module_id,
        //       ...rest,
        //     },
        //   ],
        // },
      })
    }
    console.log('data', data)
  }
  const onSelectChange = (value: any, option: any) => {
    console.log('data', option)
    onChangePermission([...option])
  }

  const validateenddate = (value: any, rule: any, callback: any) => {
    const start_date = dayjs(formProps?.form?.getFieldValue('start_date'))?.format('YYYY-MM-DD')
    // console.log('validate_value', value)
    const end_date = dayjs(value)?.format('YYYY-MM-DD')
    if (dayjs(start_date).isSame(end_date, 'day')) {
      callback('Start date & end date should not be same')
    } else {
      callback()
    }
  }
  // console.log('module_permissions', modulePermissions)
  return (
    <Modal
      {...modalProps}
      title="Create Task"
      okButtonProps={{ hidden: true }}
      cancelButtonProps={{ hidden: true }}
      footer={[
        <Button onClick={onCancel}>Cancel</Button>,
        <Button type="primary" onClick={formProps?.form?.submit}>
          Submit
        </Button>,
      ]}
    >
      <Form {...formProps} layout="vertical" onFinish={onFinish}>
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={6}>
            <Form.Item
              label="Task Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: 'Field Required !',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col lg={6} xs={24}>
            <Form.Item
              label="Start Date"
              name="start_date"
              rules={[{ required: true, message: 'Field Required !' }]}
              getValueProps={value => ({
                value: value ? dayjs(value) : '',
              })}
            >
              <DatePicker style={{ width: '100%' }} disabledDate={disabledDate} />
            </Form.Item>
          </Col>
          <Col lg={6} xs={24}>
            <Form.Item
              label="End Date"
              name="end_date"
              rules={[
                { required: true, message: 'Field Required !' },
                {
                  validator: validateenddate,
                  // message: 'End date Should not be same as start date',
                },
              ]}
              getValueProps={value => ({
                value: value ? dayjs(value) : '',
              })}
            >
              <DatePicker style={{ width: '100%' }} disabledDate={disabledDate} />
            </Form.Item>
          </Col>
          <Col lg={6} xs={24}>
            <Form.Item label="Assignee" name="assignee_id">
              <Select allowClear onChange={undefined} options={users} />
            </Form.Item>
          </Col>
          <Col lg={24} xs={24}>
            <Form.Item
              label="Modules"
              name="module_id"
              rules={[
                {
                  required: true,
                  message: 'Field Required !',
                },
              ]}
            >
              <Select {...moduleProps} onChange={onSelectChange} mode="multiple" allowClear />
            </Form.Item>
          </Col>
          <Col lg={24} xs={24}>
            <Form.Item
              label="Task Description"
              name="description"
              rules={[
                {
                  required: true,
                  message: 'Field Required !',
                },
              ]}
            >
              <Input.TextArea rows={4} />
            </Form.Item>
          </Col>
        </Row>
        {/* iterate the modules with permissions */}
        {permission?.length > 0 && (
          <>
            <h1>Module Permissions</h1>
            {permission?.map((module: any, index: number) => (
              <Row gutter={16} key={index}>
                <Col lg={24}>
                  <h1>{module?.label}</h1>
                </Col>
                <Col lg={4}>
                  <Form.Item name="can_read">
                    <Checkbox
                      // onChange={(e: any) =>
                      //   formProps?.form?.setFieldsValue({
                      //     can_read: e?.target?.checked,
                      //   })
                      // }
                      onChange={(e: any) => onCheckRead(e, index)}
                    >
                      View
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Col lg={4}>
                  <Form.Item name="can_create">
                    <Checkbox
                      // onChange={(e: any) =>
                      //   formProps?.form?.setFieldsValue({
                      //     can_create: e?.target?.checked,
                      //   })
                      // }
                      onChange={(e: any) => onCheckCreate(e, index)}
                    >
                      Create
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Col lg={4}>
                  <Form.Item name="can_update">
                    <Checkbox
                      // onChange={(e: any) =>
                      //   formProps?.form?.setFieldsValue({
                      //     can_update: e?.target?.checked,
                      //   })
                      // }
                      onChange={(e: any) => onCheckUpd(e, index)}
                    >
                      Edit
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Col lg={4}>
                  <Form.Item name="can_delete">
                    <Checkbox
                      // onChange={(e: any) =>
                      //   formProps?.form?.setFieldsValue({
                      //     can_delete: e?.target?.checked,
                      //   })
                      // }
                      onChange={(e: any) => onCheckDel(e, index)}
                    >
                      Delete
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>
            ))}
          </>
        )}
        {/* <Row gutter={16}>
          <Col lg={4}>
            <Form.Item name="can_read">
              <Checkbox
                onChange={(e: any) =>
                  formProps?.form?.setFieldsValue({
                    can_read: e?.target?.checked,
                  })
                }
              >
                View
              </Checkbox>
            </Form.Item>
          </Col>
          <Col lg={4}>
            <Form.Item name="can_create">
              <Checkbox
                onChange={(e: any) =>
                  formProps?.form?.setFieldsValue({
                    can_create: e?.target?.checked,
                  })
                }
              >
                Create
              </Checkbox>
            </Form.Item>
          </Col>
          <Col lg={4}>
            <Form.Item name="can_update">
              <Checkbox
                onChange={(e: any) =>
                  formProps?.form?.setFieldsValue({
                    can_update: e?.target?.checked,
                  })
                }
              >
                Edit
              </Checkbox>
            </Form.Item>
          </Col>
          <Col lg={4}>
            <Form.Item name="can_delete">
              <Checkbox
                onChange={(e: any) =>
                  formProps?.form?.setFieldsValue({
                    can_delete: e?.target?.checked,
                  })
                }
              >
                Delete
              </Checkbox>
            </Form.Item>
          </Col>
        </Row> */}
      </Form>
    </Modal>
  )
}

export default SupportTaskCreate
